import { CheckoutState } from '../../state';
import { getIsEnablePaymentConstraintsInNewCreate } from '../app';
import {
    getIsFreeEvent,
    getIsReservedSeating,
    hasSpecialInstructions,
    isWaitlistEnabled,
} from '../event';

export const areSyncExpressCheckoutEligibleCommonRulesMet = (
    state: CheckoutState,
) =>
    !getIsEnablePaymentConstraintsInNewCreate(state) &&
    !getIsFreeEvent(state) &&
    !getIsReservedSeating(state) &&
    !hasSpecialInstructions(state) &&
    !isWaitlistEnabled(state);
